import React, { useEffect, useState, useContext } from "react";
import {
  Checkbox,
  Box,
  Button,
  IconButton,
  Modal,
  Switch,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { Reorder } from "framer-motion";
import {
  Cards,
  CaretDown,
  Check,
  CheckSquareOffset,
  CirclesThreePlus,
  Clock,
  Cube,
  DotsSixVertical,
  FilmSlate,
  FilmStrip,
  FolderStar,
  PencilSimple,
  Plus,
  PushPin,
  PushPinSimple,
  Trash,
} from "phosphor-react";
import { fget, fpost } from "../../../../API/callsAPI";
import { MovieColabContext } from "../../../../Context/MovieColabContext";
import CustomDropdown from "../../../Utilities/CustomDropdown/CustomDropdown.component";
import { EpisodesIconCustom } from "../../../Utilities/Svg/EpisodesIcon";
import { ProjectMediaIconCustom } from "../../../Utilities/Svg/ProjectMediaIcon";
import { ReviewerIcon } from "../../../Utilities/Svg/Reviewer";
import useStyles from "./NavigationsSettings.style";
import RoleBasedNavigation from "../AllNavigations/RoleBasedNavigation";
import MyNavigation from "../AllNavigations/MyNavigation";

const navigationTabSx = {
  minHeight: "auto",
  fontSize: "14px !important",
  textTransform: "none",
  color: "#B1B5C9",
  "&.Mui-selected": {
    color: "#F9F9F9",
    boxShadow: "inset 0 -2px 0 #6C65D9",
  },
};

const NavigationsSettings = ({ setSnackValue, projectId }) => {
  const classes = useStyles();
  const { projectItems } = useContext(MovieColabContext);
  const [activeTab, setActiveTab] = useState("my-navigation");
  const [myRole, setMyRole] = useState(null);


  useEffect(() => {
    const projectRole = projectItems?.find(
      (item) => item.id == projectId,
    )?.role;
    if (projectRole) {
      setMyRole(projectRole);
    }
  }, [projectId, projectItems]);

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>Navigation Settings</Typography>
      <Tabs
        value={activeTab}
        onChange={(_, value) => setActiveTab(value)}
        sx={{
          "& .MuiTabs-indicator": {
            display: "none",
          },
        }}
      >
        {myRole === "admin" && (
          <Tab
            disabled={myRole !== "admin"}
            label="Project Defaults"
            value={"project-defaults"}
            sx={navigationTabSx}
          />
        )}
        <Tab
          label="My Navigation"
          value={"my-navigation"}
          sx={navigationTabSx}
        />
      </Tabs>
      {activeTab === "project-defaults" ? (
        <RoleBasedNavigation
          setSnackValue={setSnackValue}
          projectId={projectId}
        />
      ) : (
        <MyNavigation setSnackValue={setSnackValue} projectId={projectId} />
      )}
    </div>
  );
};

export default NavigationsSettings;
